resetCaching